import Tooltip from 'bootstrap/js/dist/tooltip';

/**
 * Initialize policy list filtering and tooltips.
 */
const initializePolicyLists = function () {
  document.querySelectorAll('.policies-list').forEach(function (block) {
    const buttons = block.querySelectorAll('[data-policy-filter]');
    const groups = block.querySelectorAll('[data-policy-view]');

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        const selectedFilter = button.dataset.policyFilter;

        /*
         * Update the selected button styling and accessibility state.
         */
        buttons.forEach(function (otherButton) {
          const isSelected = otherButton === button;

          otherButton.classList.toggle('btn-primary', isSelected);

          otherButton.classList.toggle('btn-outline-primary', !isSelected);

          otherButton.setAttribute(
            'aria-pressed',
            isSelected ? 'true' : 'false'
          );
        });

        /*
         * All uses the alphabetical view.
         * 0-9 uses the numeric view.
         * A-Z displays one alphabetical group.
         */
        groups.forEach(function (group) {
          const groupView = group.dataset.policyView;
          const groupLetter = group.dataset.policyGroup;

          let shouldShow = false;

          if (selectedFilter === 'all') {
            shouldShow = groupView === 'alphabet';
          } else if (selectedFilter === '0-9') {
            shouldShow = groupView === 'numeric';
          } else {
            shouldShow =
              groupView === 'alphabet' && groupLetter === selectedFilter;
          }

          group.hidden = !shouldShow;
        });

        /*
         * Do not leave the tooltip visible after clicking.
         */
        const tooltip = Tooltip.getInstance(button);

        if (tooltip) {
          tooltip.hide();
        }

        button.blur();
      });
    });

    /*
     * Tooltips are initialized only on enabled filter buttons. Manual events
     * prevent a clicked/focused button from keeping its tooltip visible.
     */
    block
      .querySelectorAll('[data-bs-toggle="tooltip"]')
      .forEach(function (element) {
        const existingTooltip = Tooltip.getInstance(element);

        if (existingTooltip) {
          existingTooltip.dispose();
        }

        const tooltip = new Tooltip(element, {
          trigger: 'manual',
        });

        element.addEventListener('mouseenter', function () {
          tooltip.show();
        });

        element.addEventListener('mouseleave', function () {
          tooltip.hide();
        });

        element.addEventListener('click', function () {
          tooltip.hide();
        });
      });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializePolicyLists);
} else {
  initializePolicyLists();
}
